import { useCallback, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import Redes from "./MarketingRedes";

/* Marketing > WhatsApp: conversaciones de Jaby, pedidos, contactos (seguimiento) y ajustes. */

const API = "/api/marketing/whatsapp";
const token = () => localStorage.getItem("token");
const AZUL = "#1565C0", OSCURO = "#0D47A1", MUTED = "#6b7280", BORDE = "#e5e7eb";
const VERDE = "#16a34a", AMBAR = "#d97706";

async function api(ruta: string, opciones: { method?: string; body?: any } = {}) {
  const r = await fetch(API + ruta, {
    method: opciones.method || "GET",
    headers: { "Content-Type": "application/json", Authorization: "Bearer " + token() },
    body: opciones.body !== undefined ? JSON.stringify(opciones.body) : undefined,
  });
  const data = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(data?.detail || "No se pudo completar");
  return data;
}

const fmt = (n: number) => "₡" + Math.round(n || 0).toLocaleString("es-CR");
const hora = (iso?: string) => {
  if (!iso) return "";
  const d = new Date(iso), hoy = new Date();
  const mismoDia = d.toDateString() === hoy.toDateString();
  return mismoDia ? d.toLocaleTimeString("es-CR", { hour: "2-digit", minute: "2-digit" })
    : d.toLocaleDateString("es-CR", { day: "numeric", month: "short" });
};
const nombreDe = (c: any) => c?.nombre || c?.nombre_perfil || c?.telefono || "Sin nombre";
const iniciales = (c: any) => {
  const n = c?.nombre || c?.nombre_perfil;
  if (!n) return "#";
  return n.split(" ").filter(Boolean).slice(0, 2).map((p: string) => p[0]).join("").toUpperCase();
};

function useAncho() {
  const [w, setW] = useState(window.innerWidth);
  useEffect(() => { const f = () => setW(window.innerWidth); window.addEventListener("resize", f); return () => window.removeEventListener("resize", f); }, []);
  return w;
}

const btn = (tipo: "normal" | "azul" | "ambar" | "verde" = "normal"): any => ({
  border: "2px solid " + (tipo === "azul" ? AZUL : tipo === "ambar" ? "#fcd34d" : tipo === "verde" ? "#86efac" : BORDE),
  background: tipo === "azul" ? AZUL : tipo === "ambar" ? "#FFFBEB" : tipo === "verde" ? "#ECFDF5" : "#fff",
  color: tipo === "azul" ? "#fff" : tipo === "ambar" ? "#92400e" : tipo === "verde" ? "#166534" : "#1f2937",
  padding: "8px 14px", borderRadius: "10px", fontWeight: 800, fontSize: "13px", cursor: "pointer", fontFamily: "Nunito,sans-serif",
});
const tarjeta: any = { background: "#fff", borderRadius: "16px", boxShadow: "0 2px 8px rgba(0,0,0,0.06)" };
const input: any = { padding: "9px 12px", border: "2px solid " + BORDE, borderRadius: "10px", fontSize: "14px", fontFamily: "Nunito,sans-serif", width: "100%", boxSizing: "border-box" };

function Etiqueta({ c }: { c: any }) {
  let t = "🤖 Jaby atendiendo", bg = "#EFF6FF", col = AZUL;
  if (c.atencion) { t = "🙋 Necesita atención"; bg = "#FFFBEB"; col = AMBAR; }
  else if (c.pausado) { t = "👤 Atiende el equipo"; bg = "#F3F4F6"; col = "#374151"; }
  else if (c.estado === "con_pedido") { t = "🛒 Con pedido"; bg = "#ECFDF5"; col = VERDE; }
  else if (c.estado === "cliente") { t = "⭐ Cliente"; bg = "#ECFDF5"; col = VERDE; }
  return <span style={{ fontSize: "11px", fontWeight: 800, padding: "2px 8px", borderRadius: "20px", background: bg, color: col, display: "inline-block", marginTop: "4px" }}>{t}</span>;
}

/* ===================== CONVERSACIONES ===================== */
function Conversaciones({ seleccion, setSeleccion, onCambio }: { seleccion: number | null; setSeleccion: (id: number | null) => void; onCambio: () => void }) {
  const ancho = useAncho();
  const movil = ancho < 900;
  const [lista, setLista] = useState<any[]>([]);
  const [filtro, setFiltro] = useState("todas");
  const [q, setQ] = useState("");
  const [hilo, setHilo] = useState<any>(null);
  const [texto, setTexto] = useState("");
  const [editando, setEditando] = useState(false);
  const [form, setForm] = useState<any>({});
  const [aviso, setAviso] = useState("");
  const [enviando, setEnviando] = useState(false);
  const fondo = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();

  const cargarLista = useCallback(() => {
    api(`/contactos?filtro=${filtro}&q=${encodeURIComponent(q)}`).then(setLista).catch(() => {});
  }, [filtro, q]);

  const cargarHilo = useCallback((id: number) => {
    api(`/contactos/${id}`).then(setHilo).catch(() => {});
  }, []);

  // Baja al último mensaje cuando cambia la conversación o llega un mensaje nuevo
  const totalMsgs = hilo?.mensajes?.length || 0, idHilo = hilo?.contacto?.id;
  useEffect(() => {
    const t = setTimeout(() => { if (fondo.current) fondo.current.scrollTop = fondo.current.scrollHeight; }, 30);
    return () => clearTimeout(t);
  }, [totalMsgs, idHilo]);

  useEffect(() => { cargarLista(); const t = setInterval(cargarLista, 10000); return () => clearInterval(t); }, [cargarLista]);
  useEffect(() => {
    if (!seleccion) { setHilo(null); return; }
    setEditando(false); setAviso("");
    cargarHilo(seleccion);
    const t = setInterval(() => cargarHilo(seleccion), 5000);
    return () => clearInterval(t);
  }, [seleccion, cargarHilo]);

  const refrescar = () => { if (seleccion) cargarHilo(seleccion); cargarLista(); onCambio(); };
  const accion = async (ruta: string, ok?: string) => {
    setAviso("");
    try { await api(`/contactos/${seleccion}${ruta}`, { method: "POST" }); if (ok) setAviso(ok); refrescar(); }
    catch (e: any) { setAviso("⚠️ " + e.message); }
  };
  const enviar = async () => {
    if (!texto.trim() || !seleccion) return;
    setEnviando(true); setAviso("");
    try { await api(`/contactos/${seleccion}/responder`, { method: "POST", body: { texto } }); setTexto(""); refrescar(); }
    catch (e: any) { setAviso("⚠️ " + e.message); }
    setEnviando(false);
  };
  const guardarDatos = async () => {
    try {
      await api(`/contactos/${seleccion}`, { method: "PUT", body: form });
      setEditando(false); refrescar();
    } catch (e: any) { setAviso("⚠️ " + e.message); }
  };

  const c = hilo?.contacto;
  const mostrarLista = !movil || !seleccion;
  const mostrarHilo = !movil || !!seleccion;

  return (
    <div style={{ ...tarjeta, display: "grid", gridTemplateColumns: movil ? "1fr" : "330px 1fr", height: movil ? "auto" : "calc(100vh - 250px)", minHeight: "520px", overflow: "hidden" }}>
      {mostrarLista && (
        <div style={{ borderRight: movil ? "none" : "1px solid " + BORDE, overflowY: "auto", display: "flex", flexDirection: "column" }}>
          <div style={{ padding: "12px", borderBottom: "1px solid " + BORDE }}>
            <input style={input} placeholder="Buscar por nombre o teléfono" value={q} onChange={e => setQ(e.target.value)} />
          </div>
          <div style={{ display: "flex", gap: "6px", padding: "10px 12px", borderBottom: "1px solid " + BORDE, flexWrap: "wrap" }}>
            {[["todas", "Todas"], ["atencion", "Necesitan atención"], ["pedido", "Con pedido"], ["equipo", "Atiende el equipo"], ["jaby", "Jaby"]].map(([k, l]) => (
              <span key={k} onClick={() => setFiltro(k)} style={{ fontSize: "12px", fontWeight: 700, padding: "4px 10px", borderRadius: "20px", cursor: "pointer", background: filtro === k ? "#EFF6FF" : "#f3f4f6", color: filtro === k ? AZUL : MUTED }}>{l}</span>
            ))}
          </div>
          {lista.length === 0 && <div style={{ padding: "40px 16px", textAlign: "center", color: "#9ca3af", fontSize: "14px" }}>Todavía no hay conversaciones{filtro !== "todas" || q ? " con este filtro" : ""}.</div>}
          {lista.map(x => (
            <div key={x.id} onClick={() => setSeleccion(x.id)}
              style={{ display: "flex", gap: "10px", padding: "12px", borderBottom: "1px solid " + BORDE, cursor: "pointer", background: seleccion === x.id ? "#EFF6FF" : "#fff" }}>
              <div style={{ width: "40px", height: "40px", borderRadius: "50%", background: "#dbeafe", color: AZUL, display: "grid", placeItems: "center", fontWeight: 800, flex: "none" }}>{iniciales(x)}</div>
              <div style={{ minWidth: 0, flex: 1 }}>
                <div style={{ display: "flex", justifyContent: "space-between", gap: "6px" }}>
                  <span style={{ fontWeight: 800, fontSize: "14px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{nombreDe(x)}</span>
                  <span style={{ fontSize: "11px", color: MUTED, flex: "none" }}>{hora(x.ultimo_mensaje_en)}</span>
                </div>
                <div style={{ fontSize: "13px", color: MUTED, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                  {x.ultimo ? (x.ultimo.rol === "jaby" ? "Jaby: " : x.ultimo.rol === "equipo" ? "Tú: " : "") + x.ultimo.texto : ""}
                </div>
                <Etiqueta c={x} />
              </div>
            </div>
          ))}
        </div>
      )}

      {mostrarHilo && (
        <div style={{ display: "flex", flexDirection: "column", minWidth: 0, minHeight: movil ? "70vh" : 0 }}>
          {!c ? (
            <div style={{ flex: 1, display: "grid", placeItems: "center", color: "#9ca3af", padding: "40px" }}>Elija una conversación de la lista</div>
          ) : (<>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: "10px", padding: "12px 16px", borderBottom: "1px solid " + BORDE, flexWrap: "wrap" }}>
              <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                {movil && <button style={btn()} onClick={() => setSeleccion(null)}>←</button>}
                <div>
                  <div style={{ fontWeight: 800 }}>{nombreDe(c)}</div>
                  <div style={{ fontSize: "13px", color: MUTED }}>{c.telefono}{c.zona ? " · " + c.zona : ""}</div>
                </div>
              </div>
              <div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
                {c.pausado
                  ? <button style={btn("azul")} onClick={() => accion("/devolver", "La conversación volvió a Jaby")}>🤖 Devolver a Jaby</button>
                  : <button style={btn("ambar")} onClick={() => accion("/tomar", "Jaby no responderá en esta conversación hasta que la devuelva")}>🙋 Tomar conversación</button>}
                {!c.cliente_id
                  ? <button style={btn("verde")} onClick={() => accion("/a-cliente", "Se agregó a Clientes")}>⭐ Pasar a Clientes</button>
                  : <button style={btn()} onClick={() => navigate("/clientes")}>Ver en Clientes</button>}
              </div>
            </div>

            {/* Ficha del contacto */}
            <div style={{ padding: "12px 16px", borderBottom: "1px solid " + BORDE, background: "#fafafa", fontSize: "13px" }}>
              {!editando ? (
                <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(150px,1fr))", gap: "8px 16px", alignItems: "start" }}>
                  {[["Nombre", c.nombre], ["Zona", c.zona], ["Dirección", c.direccion], ["Cédula (factura)", c.cedula], ["Correo", c.email], ["Le interesa", c.intereses]].map(([l, v]) => (
                    <div key={l as string}><div style={{ fontSize: "11px", color: MUTED, fontWeight: 800, textTransform: "uppercase" }}>{l}</div>{v || <span style={{ color: "#9ca3af" }}>—</span>}</div>
                  ))}
                  <div><div style={{ fontSize: "11px", color: MUTED, fontWeight: 800, textTransform: "uppercase" }}>Ofertas por WhatsApp</div>
                    {c.acepta_ofertas === true ? <b style={{ color: VERDE }}>✓ Aceptó</b> : c.acepta_ofertas === false ? <span>No</span> : <span style={{ color: "#9ca3af" }}>Sin preguntar</span>}</div>
                  <div><button style={{ ...btn(), padding: "6px 10px" }} onClick={() => { setForm({ nombre: c.nombre || "", zona: c.zona || "", direccion: c.direccion || "", cedula: c.cedula || "", email: c.email || "", intereses: c.intereses || "", notas: c.notas || "" }); setEditando(true); }}>✏️ Editar datos</button></div>
                </div>
              ) : (
                <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(180px,1fr))", gap: "8px" }}>
                  {[["nombre", "Nombre"], ["zona", "Zona"], ["direccion", "Dirección"], ["cedula", "Cédula"], ["email", "Correo"], ["intereses", "Le interesa"], ["notas", "Notas internas"]].map(([k, l]) => (
                    <label key={k} style={{ fontSize: "12px", fontWeight: 700, color: MUTED }}>{l}
                      <input style={{ ...input, marginTop: "4px" }} value={form[k]} onChange={e => setForm({ ...form, [k]: e.target.value })} /></label>
                  ))}
                  <div style={{ display: "flex", gap: "8px", alignItems: "flex-end" }}>
                    <button style={btn("azul")} onClick={guardarDatos}>Guardar</button>
                    <button style={btn()} onClick={() => setEditando(false)}>Cancelar</button>
                  </div>
                </div>
              )}
            </div>

            <div ref={fondo} style={{ flex: 1, overflowY: "auto", padding: "16px", background: "#efeae2", display: "flex", flexDirection: "column", gap: "8px" }}>
              {hilo.mensajes.map((m: any) => {
                if (m.rol === "sistema") {
                  const ped = m.pedido_id && hilo.pedidos.find((p: any) => p.id === m.pedido_id);
                  return (
                    <div key={m.id} style={{ alignSelf: "center", background: ped ? "#fff" : "rgba(255,255,255,.85)", border: ped ? "2px solid #bbf7d0" : "none", fontSize: "12px", color: ped ? "#166534" : MUTED, padding: "6px 12px", borderRadius: "10px", textAlign: "center", maxWidth: "85%" }}>
                      {m.texto}{ped && <> · <b>{ped.estado}</b>{ped.facturado ? " · facturado" : ""} · <a href="/pedidos" onClick={e => { e.preventDefault(); navigate("/pedidos"); }} style={{ color: AZUL }}>ver en Pedidos</a></>}
                      <div style={{ fontSize: "10px", color: "#9ca3af" }}>{hora(m.creado_en)}</div>
                    </div>
                  );
                }
                const deCliente = m.rol === "cliente";
                return (
                  <div key={m.id} style={{ maxWidth: "75%", alignSelf: deCliente ? "flex-start" : "flex-end", background: deCliente ? "#fff" : m.rol === "equipo" ? "#fff3c4" : "#d9fdd3", padding: "8px 12px", borderRadius: "12px", fontSize: "14px", lineHeight: 1.4, boxShadow: "0 1px 1px rgba(0,0,0,.08)", whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
                    {!deCliente && <div style={{ fontSize: "11px", fontWeight: 800, color: m.rol === "equipo" ? "#92400e" : AZUL, marginBottom: "2px" }}>{m.rol === "equipo" ? "Equipo B&Y" : "Jaby"}</div>}
                    {m.texto}
                    <div style={{ fontSize: "10px", color: MUTED, textAlign: "right", marginTop: "3px" }}>{hora(m.creado_en)}</div>
                  </div>
                );
              })}
            </div>

            {aviso && <div style={{ padding: "8px 16px", fontSize: "13px", background: aviso.startsWith("⚠️") ? "#FEF2F2" : "#EFF6FF", color: aviso.startsWith("⚠️") ? "#991b1b" : AZUL }}>{aviso}</div>}
            {c.ventana_abierta ? (<>
              <div style={{ display: "flex", gap: "8px", padding: "12px", borderTop: "1px solid " + BORDE, background: "#fff" }}>
                <input style={input} placeholder="Escribir como Importaciones B&Y…" value={texto} onChange={e => setTexto(e.target.value)} onKeyDown={e => { if (e.key === "Enter") enviar(); }} />
                <button style={btn("azul")} disabled={enviando} onClick={enviar}>{enviando ? "…" : "Enviar"}</button>
              </div>
              <div style={{ fontSize: "12px", color: MUTED, padding: "0 12px 10px", background: "#fff" }}>Al escribir aquí, Jaby se pausa en esta conversación hasta que la devuelva.</div>
            </>) : (
              <div style={{ padding: "12px 16px", fontSize: "13px", color: MUTED, borderTop: "1px solid " + BORDE, background: "#fff" }}>
                Pasaron más de 24 horas desde el último mensaje del cliente: WhatsApp no permite escribirle libremente hasta que vuelva a escribir.
              </div>
            )}
          </>)}
        </div>
      )}
    </div>
  );
}

/* ===================== PEDIDOS ===================== */
function PedidosWhatsApp({ abrirChat }: { abrirChat: (id: number) => void }) {
  const [pedidos, setPedidos] = useState<any[] | null>(null);
  const navigate = useNavigate();
  useEffect(() => { api("/pedidos").then(setPedidos).catch(() => setPedidos([])); }, []);
  const colores: any = { pendiente: AMBAR, confirmado: AZUL, enviado: "#7c3aed", entregado: VERDE, cancelado: "#dc2626" };
  if (pedidos === null) return <div style={{ color: MUTED }}>Cargando…</div>;
  return (
    <div>
      {pedidos.length === 0 && <div style={{ ...tarjeta, padding: "60px", textAlign: "center", color: "#9ca3af" }}>Jaby todavía no ha registrado pedidos</div>}
      {pedidos.map(p => {
        const items = typeof p.items === "string" ? JSON.parse(p.items) : (p.items || []);
        return (
          <div key={p.id} style={{ ...tarjeta, padding: "18px", marginBottom: "12px", borderLeft: `4px solid ${colores[p.estado] || "#ccc"}` }}>
            <div style={{ display: "flex", justifyContent: "space-between", gap: "12px", flexWrap: "wrap" }}>
              <div>
                <div style={{ fontWeight: 800, fontSize: "16px" }}>#{p.id} — {p.nombre_cliente}
                  <span style={{ fontSize: "11px", fontWeight: 800, background: "#dcfce7", color: "#166534", padding: "2px 8px", borderRadius: "6px", marginLeft: "8px" }}>💬 WhatsApp · Jaby</span>
                  {p.facturado && <span style={{ marginLeft: "6px", fontSize: "11px", background: "#ECFDF5", color: "#065F46", padding: "2px 8px", borderRadius: "6px", fontWeight: 700 }}>✓ Facturado</span>}
                </div>
                <div style={{ fontSize: "13px", color: MUTED }}>📞 {p.telefono} {p.direccion && `| 📍 ${p.direccion}`} · {hora(p.creado_en)}</div>
                <div style={{ marginTop: "6px" }}>{items.map((i: any, k: number) => (
                  <span key={k} style={{ background: "#EFF6FF", color: AZUL, padding: "2px 8px", borderRadius: "6px", marginRight: "4px", fontWeight: 700, fontSize: "13px", display: "inline-block", marginTop: "4px" }}>{i.nombre} x{i.cantidad}{i.detalle ? ` (${i.detalle})` : ""}</span>
                ))}</div>
              </div>
              <div style={{ textAlign: "right" }}>
                <div style={{ fontFamily: "Montserrat,sans-serif", fontSize: "20px", fontWeight: 900, color: AZUL }}>{fmt(p.total)}</div>
                <div style={{ fontSize: "13px", fontWeight: 800, color: colores[p.estado] || MUTED, marginTop: "2px" }}>{p.estado}</div>
                <div style={{ marginTop: "8px", display: "flex", gap: "6px", justifyContent: "flex-end", flexWrap: "wrap" }}>
                  {p.contacto_id && <button style={btn()} onClick={() => abrirChat(p.contacto_id)}>Ver conversación</button>}
                  <button style={btn("azul")} onClick={() => navigate("/pedidos")}>Gestionar en Pedidos</button>
                </div>
              </div>
            </div>
          </div>
        );
      })}
      <p style={{ color: MUTED, fontSize: "13px" }}>Estos pedidos son los mismos de la página <b>Pedidos</b>: ahí se cambian de estado y se facturan como siempre.</p>
    </div>
  );
}

/* ===================== CONTACTOS Y SEGUIMIENTO ===================== */
const COLUMNAS = [["nuevo", "🆕 Nuevos"], ["interesado", "🤔 Interesados"], ["con_pedido", "🛒 Con pedido"], ["cliente", "⭐ Clientes"]];

function Contactos({ abrirChat }: { abrirChat: (id: number) => void }) {
  const [lista, setLista] = useState<any[]>([]);
  const [verDescartados, setVerDescartados] = useState(false);
  const cargar = () => api("/contactos").then(setLista).catch(() => {});
  useEffect(() => { cargar(); }, []);
  const editar = async (id: number, body: any) => { await api(`/contactos/${id}`, { method: "PUT", body }).catch(() => {}); cargar(); };
  const hoy = new Date().toISOString().slice(0, 10);
  const columnas = verDescartados ? [...COLUMNAS, ["descartado", "🗂️ Descartados"]] : COLUMNAS;

  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between", gap: "12px", flexWrap: "wrap", marginBottom: "12px", alignItems: "center" }}>
        <p style={{ color: MUTED, fontSize: "14px", margin: 0 }}>Cada persona que escribe queda como contacto con los datos que Jaby le pidió. Cambie la etapa y anote cuándo darle seguimiento.</p>
        <label style={{ fontSize: "13px", color: MUTED, display: "flex", gap: "6px", alignItems: "center" }}><input type="checkbox" checked={verDescartados} onChange={e => setVerDescartados(e.target.checked)} /> Ver descartados</label>
      </div>
      <div style={{ display: "grid", gridTemplateColumns: `repeat(${columnas.length}, minmax(240px, 1fr))`, gap: "12px", overflowX: "auto", paddingBottom: "8px" }}>
        {columnas.map(([estado, titulo]) => {
          const items = lista.filter(c => c.estado === estado);
          return (
            <div key={estado} style={{ background: "#e9edf3", borderRadius: "14px", padding: "10px", minHeight: "200px" }}>
              <div style={{ fontWeight: 800, fontSize: "13px", margin: "4px 6px 10px", display: "flex", justifyContent: "space-between" }}>{titulo}<span style={{ background: "#fff", borderRadius: "20px", padding: "0 8px", color: MUTED }}>{items.length}</span></div>
              {items.map(c => {
                const vencido = c.seguimiento_fecha && c.seguimiento_fecha <= hoy;
                return (
                  <div key={c.id} style={{ background: "#fff", borderRadius: "12px", padding: "12px", marginBottom: "8px", boxShadow: "0 1px 3px rgba(0,0,0,.06)", fontSize: "13px" }}>
                    <div style={{ display: "flex", justifyContent: "space-between", gap: "6px" }}>
                      <span style={{ fontWeight: 800, fontSize: "14px", cursor: "pointer", color: OSCURO }} onClick={() => abrirChat(c.id)}>{nombreDe(c)}</span>
                      {c.atencion && <span title="Necesita atención">🙋</span>}
                    </div>
                    <div style={{ color: MUTED }}>📞 {c.telefono}{c.zona ? " · " + c.zona : ""}</div>
                    <div style={{ marginTop: "4px" }}>
                      {(c.intereses || "").split(",").filter((x: string) => x.trim()).slice(0, 3).map((x: string) => (
                        <span key={x} style={{ display: "inline-block", fontSize: "11px", fontWeight: 800, padding: "2px 7px", borderRadius: "6px", margin: "2px 4px 0 0", background: "#EFF6FF", color: AZUL }}>{x.trim()}</span>))}
                      {c.acepta_ofertas && <span style={{ display: "inline-block", fontSize: "11px", fontWeight: 800, padding: "2px 7px", borderRadius: "6px", marginTop: "2px", background: "#ECFDF5", color: VERDE }}>✓ Ofertas</span>}
                    </div>
                    <div style={{ marginTop: "8px", paddingTop: "8px", borderTop: "1px dashed " + BORDE, display: "grid", gap: "6px" }}>
                      <select value={c.estado} onChange={e => editar(c.id, { estado: e.target.value })} style={{ ...input, padding: "6px 8px", fontSize: "13px" }}>
                        <option value="nuevo">🆕 Nuevo</option><option value="interesado">🤔 Interesado</option>
                        <option value="con_pedido">🛒 Con pedido</option><option value="cliente">⭐ Cliente</option><option value="descartado">🗂️ Descartado</option>
                      </select>
                      <div style={{ display: "flex", gap: "6px" }}>
                        <input type="date" value={c.seguimiento_fecha || ""} onChange={e => editar(c.id, e.target.value ? { seguimiento_fecha: e.target.value } : { quitar_seguimiento: true })} style={{ ...input, padding: "6px 8px", fontSize: "13px", borderColor: vencido ? "#fcd34d" : BORDE, background: vencido ? "#FFFBEB" : "#fff" }} />
                      </div>
                      <input placeholder="Nota de seguimiento" defaultValue={c.seguimiento_nota || ""} onBlur={e => { if (e.target.value !== (c.seguimiento_nota || "")) editar(c.id, { seguimiento_nota: e.target.value }); }} style={{ ...input, padding: "6px 8px", fontSize: "13px" }} />
                      {vencido && <div style={{ fontWeight: 800, color: AMBAR }}>⏰ Toca dar seguimiento</div>}
                    </div>
                  </div>
                );
              })}
            </div>
          );
        })}
      </div>
    </div>
  );
}

/* ===================== JABY Y CONSUMO ===================== */
function Ajustes({ resumen }: { resumen: any }) {
  const [cfg, setCfg] = useState<any>(null);
  const [guardado, setGuardado] = useState("");
  useEffect(() => { api("/config").then(setCfg).catch(() => {}); }, []);
  const guardar = async (cambios: any) => {
    const nuevo = { ...cfg, ...cambios };
    setCfg(nuevo);
    try { setCfg(await api("/config", { method: "PUT", body: cambios })); setGuardado("✓ Guardado"); setTimeout(() => setGuardado(""), 2000); }
    catch { setGuardado("⚠️ No se pudo guardar"); }
  };
  const kpi = (l: string, v: any, d: string) => (
    <div style={{ ...tarjeta, padding: "16px" }}>
      <div style={{ fontSize: "12px", color: MUTED, fontWeight: 800, textTransform: "uppercase", letterSpacing: ".04em" }}>{l}</div>
      <div style={{ fontFamily: "Montserrat,sans-serif", fontWeight: 900, fontSize: "26px", marginTop: "4px", color: "#1a1a2e" }}>{v}</div>
      <div style={{ fontSize: "12px", color: MUTED }}>{d}</div>
    </div>
  );
  const sw = (k: string) => (
    <label style={{ position: "relative", width: "46px", height: "26px", flex: "none", cursor: "pointer" }}>
      <input type="checkbox" checked={!!cfg?.[k]} onChange={e => guardar({ [k]: e.target.checked })} style={{ opacity: 0, width: 0, height: 0 }} />
      <span style={{ position: "absolute", inset: 0, background: cfg?.[k] ? VERDE : "#cbd5e1", borderRadius: "26px", transition: ".2s" }} />
      <span style={{ position: "absolute", width: "20px", height: "20px", top: "3px", left: cfg?.[k] ? "23px" : "3px", background: "#fff", borderRadius: "50%", transition: ".2s" }} />
    </label>
  );
  const fila = (t: string, d: string, control: any) => (
    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: "16px", padding: "14px 18px", borderBottom: "1px solid " + BORDE, flexWrap: "wrap" }}>
      <div style={{ flex: "1 1 260px" }}><div style={{ fontWeight: 800 }}>{t}</div><div style={{ fontSize: "13px", color: MUTED }}>{d}</div></div>{control}
    </div>
  );
  const r = resumen || {};
  return (
    <div>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(200px,1fr))", gap: "12px", marginBottom: "16px" }}>
        {kpi("Conversaciones este mes", r.conversaciones_mes ?? "—", `${r.contactos_total ?? 0} contactos en total`)}
        {kpi("Pedidos de Jaby (mes)", r.pedidos_mes ?? "—", fmt(r.pedidos_total_mes || 0) + " en pedidos")}
        {kpi("Atendidas solo por Jaby", r.solo_jaby_pct != null ? r.solo_jaby_pct + "%" : "—", "sin intervención del equipo")}
        {kpi("Costo de IA (mes)", r.costo_usd_mes != null ? "$" + Number(r.costo_usd_mes).toFixed(2) : "—", r.costo_por_conversacion_usd != null ? `$${Number(r.costo_por_conversacion_usd).toFixed(3)} por conversación` : "por conversación")}
      </div>
      {!cfg ? <div style={{ color: MUTED }}>Cargando…</div> : (
        <div style={tarjeta}>
          {fila("Jaby activo en WhatsApp", "Si lo apaga, los mensajes quedan en Conversaciones para que el equipo responda.", sw("jaby_activo"))}
          {fila("Jaby puede registrar pedidos", "Registra el pedido cuando el cliente confirma productos, nombre y dirección.", sw("pedidos_activos"))}
          {fila("Jaby pide los datos del cliente", "Nombre, zona y dirección; cédula solo si quiere factura electrónica; y si acepta recibir ofertas.", sw("pedir_datos"))}
          {fila("Avisarme por notificación", "Cuando alguien pide una persona o Jaby registra un pedido (app del admin).", sw("avisar_atencion"))}
          {fila("Horario de atención del equipo", "Fuera de este horario Jaby avisa que le responden en el próximo horario.",
            <div style={{ display: "flex", gap: "6px", alignItems: "center" }}>
              <input type="time" value={cfg.horario_inicio} onChange={e => guardar({ horario_inicio: e.target.value })} style={{ ...input, width: "auto" }} /> a
              <input type="time" value={cfg.horario_fin} onChange={e => guardar({ horario_fin: e.target.value })} style={{ ...input, width: "auto" }} />
            </div>)}
          {fila("Saludo de Jaby", "Primer mensaje de cada conversación nueva.",
            <input defaultValue={cfg.saludo} onBlur={e => { if (e.target.value !== cfg.saludo) guardar({ saludo: e.target.value }); }} style={{ ...input, width: "min(420px,100%)" }} />)}
          <div style={{ padding: "10px 18px", fontSize: "13px", color: guardado.startsWith("⚠️") ? "#991b1b" : VERDE, minHeight: "20px" }}>{guardado}</div>
        </div>
      )}
    </div>
  );
}

/* ===================== PÁGINA ===================== */
export default function Marketing() {
  const [seccion, setSeccion] = useState(() => { try { return localStorage.getItem("mk_seccion") || "whatsapp"; } catch { return "whatsapp"; } });
  const cambiarSeccion = (s: string) => { setSeccion(s); try { localStorage.setItem("mk_seccion", s); } catch { /* sin almacenamiento */ } };
  const [tab, setTab] = useState("conv");
  const [seleccion, setSeleccion] = useState<number | null>(null);
  const [resumen, setResumen] = useState<any>(null);
  const cargarResumen = useCallback(() => { api("/resumen").then(setResumen).catch(() => {}); }, []);
  useEffect(() => { cargarResumen(); const t = setInterval(cargarResumen, 30000); return () => clearInterval(t); }, [cargarResumen]);
  const abrirChat = (id: number) => { setSeleccion(id); setTab("conv"); };

  const pestana = (k: string, l: string, n?: number) => (
    <button key={k} onClick={() => setTab(k)} style={{ border: "2px solid " + (tab === k ? AZUL : BORDE), background: tab === k ? AZUL : "#fff", color: tab === k ? "#fff" : MUTED, padding: "9px 16px", borderRadius: "50px", fontWeight: 700, fontSize: "14px", cursor: "pointer", fontFamily: "Nunito,sans-serif" }}>
      {l}{n ? <span style={{ background: "#dc2626", color: "#fff", borderRadius: "20px", padding: "0 7px", fontSize: "12px", marginLeft: "6px" }}>{n}</span> : null}
    </button>
  );

  return (
    <div>
      <h1 style={{ fontFamily: "Montserrat,sans-serif", fontSize: "24px", fontWeight: 900, margin: "0 0 4px", color: "#1a1a2e" }}>Marketing</h1>
      <p style={{ color: MUTED, margin: "0 0 16px", fontSize: "14px" }}>Atención por WhatsApp con Jaby, contactos, seguimiento y publicaciones en redes sociales.</p>

      <div style={{ display: "flex", gap: "8px", marginBottom: "16px", borderBottom: "2px solid " + BORDE, flexWrap: "wrap" }}>
        {[["whatsapp", "💬 WhatsApp"], ["redes", "📣 Redes sociales"]].map(([k, l]) => (
          <div key={k} onClick={() => cambiarSeccion(k)} style={{ padding: "10px 4px", fontWeight: 800, cursor: "pointer", color: seccion === k ? OSCURO : MUTED, borderBottom: "3px solid " + (seccion === k ? OSCURO : "transparent"), marginBottom: "-2px", marginRight: "16px" }}>{l}</div>
        ))}
      </div>

      {seccion === "redes" ? <Redes /> : (<>
      <div style={{ display: "flex", gap: "6px", marginBottom: "16px", flexWrap: "wrap" }}>
        {pestana("conv", "💬 Conversaciones", resumen?.necesitan_atencion)}
        {pestana("ped", "🛒 Pedidos de WhatsApp")}
        {pestana("cont", "👤 Contactos y seguimiento", resumen?.seguimientos_hoy)}
        {pestana("aj", "⚙️ Jaby y consumo")}
      </div>

      {tab === "conv" && <Conversaciones seleccion={seleccion} setSeleccion={setSeleccion} onCambio={cargarResumen} />}
      {tab === "ped" && <PedidosWhatsApp abrirChat={abrirChat} />}
      {tab === "cont" && <Contactos abrirChat={abrirChat} />}
      {tab === "aj" && <Ajustes resumen={resumen} />}
      </>)}
    </div>
  );
}
